/**
 * 呼入排队人数显示组件
 * @author easonmma
 */
import React, { FunctionComponent, useEffect, useState } from 'react'
import { useQueueInfo, UseQueueInfoOptions } from '@hooks/useQueueInfo'
import { getSalesT3CSkillGroup } from '@services/t3c'

export interface QueueInfoProps extends UseQueueInfoOptions {
  // 继承 UseQueueInfoOptions 的所有属性
}

export const QueueInfoComponent: FunctionComponent<QueueInfoProps> = (props) => {
  const { queueInfo } = useQueueInfo(props)
  const [show, setShow] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      const [res] = await getSalesT3CSkillGroup()
      if (res) {
        const result = res?.skillGroups.find(item => item.isInbound)
        if (result) {
          setShow(true)
        } else {
          setShow(false)
        }
      }
    }

    fetchData()
  }, [])
  return show ? (
    <div className="queue-info">
      <div className="queue-info-content">
        {queueInfo.skillGroups.length > 0 && (
          <div className="skill-group-info" style={{
            fontSize: '12px',
            marginTop: 2,
          }}>
            {queueInfo.skillGroups.map((group) => (
              <div className="item" key={group.skillGroupId}>
                {group.skillGroupName}-排队：{group.queueCount}人
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  ) : null
}
